import getAPIResponse from "../../../Shared/Utils/Domain/Services/GetAPIResponsePrivateService";
import { Me } from "../Responses/Me";

export async function getMe() {
	let response = await getAPIResponse("/v1/user/me");
	if (response === null) {
		return null;
	}
	let me = Me.createFromResponseData(response);
	return me;
}